import React from 'react';
import { Chip } from '@mui/material';

interface PriorityChipProps {
  priorityId?: number;
  priorities?: any[];
  authUser: any;
}

export const PriorityChip: React.FC<PriorityChipProps> = ({ 
  priorityId,
  priorities = [], 
  authUser 
}) => {
  if (authUser?.role === 'customer') {
    return null;
  }

  const priority = priorities.find(p => p.id === priorityId);
  if (!priority) return <Chip label="❓ Bilinmeyen" size="small" sx={{ fontSize: '0.75rem' }} />;

  // Number key'ler kullan
  const priorityConfig: { [key: number]: any } = {
    1: { 
      color: 'success' as const, 
      icon: '🟢', 
      label: 'Düşük',
      bgColor: '#e8f5e8',
      textColor: '#2e7d32'
    },
    2: { 
      color: 'info' as const, 
      icon: '🔵', 
      label: 'Orta',
      bgColor: '#e3f2fd',
      textColor: '#1565c0'
    },
    3: { 
      color: 'warning' as const, 
      icon: '🟠', 
      label: 'Yüksek',
      bgColor: '#fff3e0',
      textColor: '#ef6c00'
    },
    4: { 
      color: 'error' as const, 
      icon: '🔴', 
      label: 'Acil',
      bgColor: '#ffebee',
      textColor: '#c62828'
    },
  };

  // Artık direkt number key kullanabiliriz
  const config = priorityConfig[priorityId || 0] || { 
    color: 'default' as const, 
    icon: '❓', 
    label: priority.name,
    bgColor: '#f5f5f5',
    textColor: '#616161'
  };

  return (
    <Chip 
      label={`${config.icon} ${config.label}`} 
      color={config.color}
      size="small"
      sx={{
        backgroundColor: config.bgColor,
        color: config.textColor,
        fontWeight: 'bold',
        fontSize: '0.75rem', // ✅ 0.75rem'den 0.7rem'e küçültüldü
        height: '24px', // ✅ Yükseklik küçültüldü
        border: `1px solid ${config.textColor}20`,
        '& .MuiChip-label': { 
          px: 0.8, // ✅ Padding küçültüldü
          fontSize: '0.75rem' // ✅ Label font da küçültüldü
        },
        minWidth: '75px' // ✅ Min width küçültüldü
      }}
    />
  );
};